module.exports = __webpack_public_path__ + "static/image/history/pc/202309.png?55e0d936";